module.exports = require("/vercel/path0/config/gatsby-browser.ts");